module.exports = __webpack_public_path__ + "static/media/Vector_left.252c1ed6.svg";